import { ReactNode } from 'react';

import { getCustomTheme } from '@utils/index';

import { AppConfigProvider } from './AppConfigContext';
import { EnvironmentModeContextProvider } from './EnvironmentModeContext';
import { IntegrationWarningProvider } from './IntegrationWarningContext';
import { SDKConfigProvider } from './SDKConfigContext';

import { JsBridgeVersionProvider } from '@/context/JsBridgeVersionContext';
import { ThemeProvider } from '@asphalt-react/theme-provider';

export const AppProviders = ({ children }: { children: ReactNode }) => {
  const theme = getCustomTheme();

  return (
    <AppConfigProvider>
      <ThemeProvider theme={theme}>
        <JsBridgeVersionProvider>
          <IntegrationWarningProvider>
            <SDKConfigProvider>
              <EnvironmentModeContextProvider>
                {children}
              </EnvironmentModeContextProvider>
            </SDKConfigProvider>
          </IntegrationWarningProvider>
        </JsBridgeVersionProvider>
      </ThemeProvider>
    </AppConfigProvider>
  );
};
